import Item from 'owa-service/lib/contract/Item';
import TableViewItemRelation from 'owa-mail-list-store/lib/store/schema/TableViewItemRelation';
import { TableView } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { ClientItemId } from 'owa-client-ids';

//TODO: 22724 itemId should be ClientItemId so we don't need this function to getMailboxInfo
export function getItemClientId(item: Item, tableView: TableView): ClientItemId {
    return { Id: item.ItemId.Id, mailboxInfo: getMailboxInfo(tableView) };
}

export default function mapItemTypeToItemRelation(
    item: Item,
    tableView: TableView
): TableViewItemRelation {
    return <TableViewItemRelation>{
        executeSearchSortOrder: item.SortOrderSource,
        clientId: getItemClientId(item, tableView),
        instanceKey: item.InstanceKey,
    };
}
